<template>
<main class="bg-main lesson-explanation">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>
  <section class="container">
    <div class="heading-content-title">
      <template v-if="step=='listening_practice'">{{ $t('lesson.listening_practice.title') }}</template>
      <template v-else-if="step=='exam'">{{ $t('lesson.exam.title') }}</template>
      <template v-else>{{ $t('lesson.question.title') }}</template>
    </div>

    <div class="row">
    
      <h2 class="h-explanation text-center">{{ $t('lesson.question.rule') }}</h2>

      <ol class="rounded-list">
        <li><p>{{ getRuleText(step, 1) }}</p></li>
        <li v-if="!isListening"><p>{{ $t('lesson.' + step + '.rule_2') }}</p></li>
        <li><p>{{ getRuleText(step, 3) }}</p></li>
      </ol>

      <div class="hint" v-if="selectedLanguage.key != 'ja'">
        <h2 class="h-explanation text-center">{{ $t('lesson.question.hint') }}</h2>
        <p class="p-explanation">{{ $t('lesson.question.hint_details') }}</p>
      </div>
      <a @click.prevent="startExam" class="button button-primary next">{{ $t('lesson.question.button.start') }}</a>
    
    </div>
    <div class="buttons-side-by-side">
      <a class="button button-default back" @click="back">{{ $t('common.button.back') }}</a>
      <a class="button disabled next">{{ $t('common.button.next') }}</a>
    </div>
  </section>
</main>

</template>

<script>

import {appEnv, useCoachmark} from './../../config';

import {mapState} from 'vuex'
import {mapGetters} from 'vuex';

import componentContentHead from '../shared/ContentHead.vue';

import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

  export default {
    name: "LessonExplanation",
    components: {
      'contenthead': componentContentHead
    },
    props: {
      step: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        authUser: null,
        driver: null,
        storage: {}
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      ...mapGetters([
        'selectedLanguage'
      ]),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      isListening() {
        if (this.step == 'listening_practice') {
          return true;
        }
        return false;
      }
    },

    created() {
      
      this.authUser = this.$store.getters.getAuthUser;
      this.initCoachMark();
    },

    mounted() {
    },
    methods: {
      startExam: function () {
        
        if(this.driver) {
          this.driver.reset();
        }
        
        let to = '';
        if (this.step == 'practice') {
          to = 'lesson.practice';
          //TODO: listening_practice or listening-practice
        } else if (this.step == 'listening_practice') {
          to = 'lesson.listening.practice';
        } else {
          to = 'lesson.exam';
        }
        this.$router.push({name: to});
      },
      getRuleText(stepType, rule_count) {
        let ruleTxt = this.$t('lesson.' + stepType + '.rule_' + rule_count)
        
        let questions = this.$store.getters.lesson_content[stepType].content.questions
        if(questions.length) {
          if(rule_count == 1) {
            ruleTxt = ruleTxt.replace('{count}', questions.length)
          } else if(rule_count == 3) {
            if(questions.length <= 3) {
              ruleTxt = ruleTxt.replace('{count}', '2')
            } else {
              ruleTxt = ruleTxt.replace('{count}', '3')
            }
          }
        }
        
        return ruleTxt
      },
      back() {
        if (this.step == 'practice') {
          this.$router.push({name: 'lesson.grammar'});
        } else if (this.step == 'listening_practice') {
          this.$router.push({name: 'lesson.review'});
        } else {
          this.$router.push({ name: 'region', params: { region: this.$store.getters.section_data.section } });
        }
      },
      initCoachMark() {
        if(this.driver) {
          this.driver.reset()
        } else {
          const driverOverlay = document.getElementById('driver-page-overlay')
          const driverStage = document.getElementById('driver-highlighted-element-stage')
          const driverItem = document.getElementById('driver-popover-item')
          const driverItem2 = document.getElementById('driver-popover-item2')
          
          if(driverOverlay) {
            driverOverlay.remove()
          }
          if(driverStage) {
            driverStage.remove()
          }
          if(driverItem) {
            driverItem.remove()
          }
        }
      }
    },
  }
</script>
<style scoped>

</style>
